<script>
import { mapActions } from 'vuex';

import Card from "../../components/Card.vue";
import SectionComponent from './sectionComponent.vue';

export default {
    components: {
        Card,
        SectionComponent,
    },

    props: {
        initialLanguage: {
            type: String,
            default: "en"
        },

        selectedReportLanguages: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            report_headers: {},
        }
    },

    computed: {
        language_key() {
            const lang = localStorage.getItem('lang');
            if (lang === 'en') return '';
            return `_${lang}`;
        },
    },

    async mounted() {
        await this._getCreatedSections();
    },

    methods: {
        ...mapActions('reports', [
            'getCreatedSections',
        ]),

        async _getCreatedSections() {
            await this.getCreatedSections({type: null, body: { company_id: this.$user.company_id}})
                .then(response => {
                    for (let i = 0; i < response.data.length; i++) {
                        const item = response.data[i];

                        const map_key = String(item.report_header_order);
                        const map_value = this.report_headers[map_key];
                        if (!map_value) {
                            const value = {
                                report_header_order: item.report_header_order,
                                [`report_header_name${this.language_key}`]: item[`report_header_name${this.language_key}`],
                                report_header_element_id: item.sust_element_id,
                                created_sections: [
                                    item
                                ]
                            };

                            Object.assign(this.report_headers, {[map_key]: value});
                        } else {
                            map_value.created_sections.push(item);
                        }
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>

<template>
    <div class="flex-all-centered-row">
        <div v-if="!loading" class="flex-all-centered-col">
            <Card v-for="(header, key) in report_headers" :key="key">
                <section-component
                    ref="sectionComponent"
                    :sections="header.created_sections"
                    :report_header="header"
                    :selected_language="initialLanguage"
                    :languages="selectedReportLanguages"
                    :show_title="true"
                    @delete="handleDelete(($event) => created_sections = $event)"
                />
            </Card>
        </div>

        <loading-spinner v-else fontSize="1.5em" />
    </div>
</template>

<style lang="scss" scoped>

</style>